// In a real app, this data would be fetched from a backend.
export const liveExams = [
  {
    id: 'live-cardio-2025',
    title: 'Cardiology Grand Challenge',
    description: 'A comprehensive live exam covering key cardiology topics.',
    // NOTE: Month is 0-indexed in JavaScript (9 = October)
    startTime: new Date('2025-09-02T01:30:00Z').getTime(), // Use UTC for consistency
    endTime: new Date('2025-09-02T18:00:00Z').getTime(),
    durationMinutes: 30,
    questionCount: 20,
    sourceFiles: ['Medicine - Cardiology.json', 'Medicine - Respiratory.json']
  },
  {
    id: 'live-surgery-nov-2025',
    title: 'Surgical Principles Review',
    description: 'A timed quiz on fundamental surgical and urological principles.',
    startTime: new Date('2025-11-10T09:00:00Z').getTime(),
    endTime: new Date('2025-11-10T17:00:00Z').getTime(),
    durationMinutes: 15,
    questionCount: 10,
    sourceFiles: ['Surgery - Urology.json']
  },
// src/data/liveExams.js

// ... (keep the other exam objects as they are) ...
// Make sure there is a comma after the previous exam object
{
    id: 'live-pass-respiratory',
    title: 'Respiratory Night Owl Quiz',
    description: 'A special late-night live quiz focusing on key respiratory cases.',

    // CORRECTED START TIME:
    // This is 7:30 PM on Oct 1st (UTC), which will display as 1:30 AM on Oct 2nd in your UTC+6 timezone.
    startTime: new Date('2025-12-08T19:30:00Z').getTime(),

    // CORRECTED END TIME:
    // This is 4 hours after the start time. 19:30 + 4 hours = 23:30 (11:30 PM UTC).
    endTime: new Date('2025-12-10T23:30:00Z').getTime(),

    durationMinutes: 20,
    questionCount: 15,
    sourceFiles: ['Medicine - GIT 1 (PassMedicine).json', 'Medicine - Respiratory (PassMedicine).json']
}
// ... (make sure there are no trailing commas if this is the last object in the array)
];
